import classnames from 'classnames';
import { ConversationDirection } from 'lib-shared-legacy-types';
import * as React from 'react';


import styles from '../styles.module.scss';

import { BothDirectionIcon } from './BothDirectionIcon';
import { OutboundDirectionIcon } from './OutboundDirectionIcon';

interface Props {
  direction?: ConversationDirection;
  size?: number | string;
  className?: string;
}

export const DirectionIcon: React.FunctionComponent<Props> = ({
  size = 16,
  direction,
  className,
}) => {
  const classNames = classnames(styles.directionIcon, className);

  const wrapperStyle = { width: size, height: size };
  switch (direction) {
    case 'outbound':
      return (
        <div className={classNames} style={wrapperStyle}>
          <OutboundDirectionIcon />
        </div>
      );

    case 'internal':
      return (
        <div className={classNames} style={wrapperStyle}>
          <BothDirectionIcon />
        </div>
      );

    default:
      return null;
  }
};
